/**
 * Background Visual
 *
 * @author Space-Time Inc.
 * @version 2022-07-25
 */

document.addEventListener('DOMContentLoaded', () => {
	var params_right = {
		container: document.getElementById('lottie-frame-right'),
		renderer: "svg",
		loop: true,
		autoplay: true,
		path     : TOP_VISUAL.asset_url + 'lottie/entry-bg.json',
	}
	var anim = lottie.loadAnimation(params_right);
	anim.setSpeed(0.4);

	var params_left = {
		container: document.getElementById('lottie-frame-left'),
		renderer: "svg",
		loop: true,
		autoplay: true,
		path     : TOP_VISUAL.asset_url + 'lottie/entry-bg.json',
	}
	var anim = lottie.loadAnimation(params_left);
	anim.setSpeed(0.3);
});
